import React, { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { WelletContext } from '../../../context/wellet/welletContext';
import { getProfilePic } from '../../../services';
import { Show } from '../../../components';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { defaultQueryOptions } from '@/utils/defaultQueryOptions';
import { Skeleton } from '@/components/ui/skeleton';

const WorkCredentialImage = ({
  url,
  name,
  style,
  className = 'tw-mt-2 tw-rounded tw-object-cover',
  t,
}) => {
  const welletContext = useContext(WelletContext);
  const profileQuery = useQuery({
    queryKey: ['credentialImage', url],
    queryFn: () => getProfilePic(welletContext, url),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    enabled: !!url,
    ...defaultQueryOptions,
  });
  const imageUrl = useMemo(
    () =>
      profileQuery.isSuccess
        ? URL.createObjectURL(new Blob([profileQuery?.data?.data], { type: 'image/jpeg' }))
        : null,
    [url, profileQuery.isSuccess, profileQuery.data],
  );

  return (
    <>
      <Show>
        <Show.When isTrue={profileQuery?.isLoading}>
          <Skeleton className='tw-h-[250px] tw-w-[250px] tw-rounded' />
        </Show.When>
        <Show.When isTrue={imageUrl}>
          <Zoom>
            <img className={className} style={style} src={imageUrl} alt={`Credential ${name}`} />
          </Zoom>
        </Show.When>
      </Show>
    </>
  );
};

export default WorkCredentialImage;
